import { GroupsResponse } from '@interpals/api-web';
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';
import { ReduxState } from 'redux/root-reducer';
import { selectGroups } from 'redux/groups/selectors';
import { GroupSearchFilters } from 'redux/groups/reducer';

export const GROUPS_PAGE_LIMIT = 10;

export const fetchGroups = createAsyncThunk<
    GroupsResponse,
    { filters: GroupSearchFilters; offset?: number },
    { state: ReduxState }
>('groups/fetch', async ({ filters, offset }, { getState }) => {
    const state = getState();

    return api.getGroups({
        ...filters,
        limit: GROUPS_PAGE_LIMIT,
        offset: offset === undefined ? selectGroups(state).length : offset,
    });
});

export const fetchUserGroups = createAsyncThunk<
    GroupsResponse,
    { userId: string; offset?: number },
    { state: ReduxState }
>('groups/fetch', async ({ userId, offset }, { getState }) => {
    const state = getState();

    return api.getUserGroups({
        id: userId,
        offset: offset === undefined ? selectGroups(state).length : offset,
    });
});
